module.exports = __webpack_public_path__ + "assets/img/WechatIMG55.f9fefb09.png";